import { render, staticRenderFns } from "./SchoolReportRequestDetail.vue?vue&type=template&id=5561a8f4&scoped=true"
import script from "./SchoolReportRequestDetail.vue?vue&type=script&lang=js"
export * from "./SchoolReportRequestDetail.vue?vue&type=script&lang=js"
import style0 from "./SchoolReportRequestDetail.vue?vue&type=style&index=0&id=5561a8f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5561a8f4",
  null
  
)

export default component.exports